import { connect } from 'react-redux';
import { isJoinModalCall } from 'actions/JoinModal';
import { callActions, mediaSelectors, userProfileSelectors } from '@lifesize/nucleus';
import { closeFullScreenModal } from 'actions/FullScreenModal';
import JoinButtons from 'components/JoinModal/JoinButtons/JoinButtons';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const primaryVideoSourceId = _get(state, 'app.avSettings.videoSourceId') || _get(mediaSelectors.selectedVideoDevice(state), 'deviceId') || -1;
  const primaryAudioSourceId = _get(state, 'app.avSettings.audioSourceId') || _get(mediaSelectors.selectedAudioDevice(state), 'deviceId') || -1;
  const videoDevices = mediaSelectors.videoDevices(state) || [];
  const audioDevices = mediaSelectors.audioDevices(state) || [];

  const selectedSources = {
    primaryVideoSourceId,
    primaryAudioSourceId
  };

  return ({
    videoDevices,
    audioDevices,
    selectedSources,
    isPSTNCall: _get(state, 'app.joinModal.isPSTNVisible'),
    defaultVideoSetting: _get(state, 'app.joinModal.isVideoEnabled'),
    defaultAudioSetting: _get(state, 'app.joinModal.isAudioEnabled'),
    isAcquiringPrimaryStream: _get(state, 'nucleus.media.isAcquiringPrimaryStream'),
    isGuest: userProfileSelectors.selectIsGuest(state),
  });
};

const mapDispatchToProps = dispatch => ({
  call: (extension, settings = { video: true, audio: true }) => {
    dispatch(isJoinModalCall());
    dispatch(closeFullScreenModal());
    setTimeout(() => {
      dispatch(callActions.call(extension, {
        video: settings.video,
        audio: settings.audio,
        primaryVideoSourceId: settings.primaryVideoSourceId,
        primaryAudioSourceId: settings.primaryAudioSourceId
      }));
    }, 0);
  },
  pstnCall: (extension, media = { video: true, audio: true }) => {
    dispatch(isJoinModalCall());
    dispatch(closeFullScreenModal());
    const mediaParam = media;
    mediaParam.audio = true;
    dispatch(callActions.webConferenceCall(extension, mediaParam));
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  Object.assign({}, ownProps, stateProps, dispatchProps,
    {
      call: () => {
        const extension = ownProps.extension;
        const primaryVideoSourceId = _get(stateProps, 'selectedSources.primaryVideoSourceId');
        const video = stateProps.videoDevices.length ? stateProps.defaultVideoSetting : false;

        if (stateProps.isPSTNCall) {
          return dispatchProps.pstnCall(extension,
            {
              video,
              primaryVideoSourceId
            }
          );
        }

        const primaryAudioSourceId = _get(stateProps, 'selectedSources.primaryAudioSourceId');
        const audio = stateProps.audioDevices.length ? stateProps.defaultAudioSetting : false;

        return dispatchProps.call(extension,
          {
            video,
            audio,
            primaryVideoSourceId,
            primaryAudioSourceId
          }
        );
      }
    }
  )
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(JoinButtons);
